import { makeObservable, observable, action } from 'mobx';
import LoginRequests from 'Utils/Requests/LoginRequests'
import AppStore from 'Stores/AppStore'
import { ShowAlert, ShowAlert2 } from "Utils/CommonFunctions";
import { WebErrorCodeEnum } from 'Utils/Requests/WebEnums';

class LoginStore {
    loading;
    passwordIsVisible;
    isOsAuth;

    constructor() {
        makeObservable(this, {
            loading: observable,
            passwordIsVisible: observable,
            isOsAuth: observable
        });
        this.login = '';
        this.password = '';
        this.passwordIsVisible = false;
        this.isOsAuth = false;
        this.loading = false;
    }

    Login = action(() => {
        this.loading = true;

        LoginRequests.Login(this.login, this.password, this.isOsAuth)
            .then(action((values) => {
                this.loading = false;

                if (!values.error) {
                    AppStore.SetLoggedInState(true);

                    AppStore.GetServiceState();
                }
                else {
                    var message = () => {
                        switch (values.error.errorCode) {
                            case WebErrorCodeEnum.LoginPasswordFailed:
                                return 'Неверное имя пользователя и(или) пароль. Проверьте правильность введенных данных.';
                            case WebErrorCodeEnum.DmsisNotWorkingError:
                                return "При попытке получить данные из сервера интеграции произошла ошибка. Убедитесь, что сервер интеграции работает, и повторите попытку.";
                            case WebErrorCodeEnum.LoginAdminFailedAndBlocked:
                                return 'Неверное имя пользователя и(или) пароль. Вход в систему заблокирован. Разблокировать доступ можно с помощью утилиты конфигурации.';
                            case WebErrorCodeEnum.LoginUserFailedAndBlocked:
                                return 'Неверное имя пользователя и(или) пароль. Вход в систему заблокирован. Обратитесь к администратору СЭД.';
                            case WebErrorCodeEnum.LoginAdminBlocked:
                                return 'Вход в систему заблокирован. Разблокировать доступ можно с помощью утилиты конфигурации.';
                            case WebErrorCodeEnum.LoginUserBlocked:
                                return 'Вход в систему заблокирован. Обратитесь к администратору СЭД.';
                            default:
                                return 'Неизвестная ошибка сервера';
                        }
                    };
                    ShowAlert('error', message());
                }
            }))
            .catch(e => {
                window.location.reload();
            });
    });

    LogOut = action(() => {
        AppStore.checkTransitionAllowed()
            .then(result => {
                if (!result)
                    return;

                LoginRequests.LogOut()
                    .then(action((values) => {
                        this.loading = false;

                        if (!values.error)
                            AppStore.SetLoggedInState(false);
                        else
                            ShowAlert('error', values.error);
                    }))
                    .finally(action(() => this.loading = false));
            });
    });
}

export default new LoginStore();